module.exports = __webpack_public_path__ + "static/media/3.659e0aca.wav";


//////////////////
// WEBPACK FOOTER
// ./src/audio/row1/3.wav
// module id = 30
// module chunks = 0